import HomePage from 'components/pages/Home';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getFeaturedOffersList, getTopOffersList } from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const DESCRIPTION =
  'Encontre o Menor Preço no Promobit: reunimos as melhores ofertas em eletrônicos, eletrodomésticos, smarthphones, TVs, notebooks, jogos e mais, confira nossa seleção!';
const PAGE_TITLE = 'Menor preço | Melhores Ofertas no Promobit';
const TAB_NAME = 'low_price';
const OFFERS_SERVER_LIMIT = 12;

const MenorPreco = ({
  cardsAds,
  landscapeAds,
  recoveryPassword,
  serverFeaturedOffers,
  serverOffers,
  smallAds,
}) => (
  <HomePage
    cardsAds={cardsAds}
    description={DESCRIPTION}
    landscapeAds={landscapeAds}
    pageTitle={PAGE_TITLE}
    recoveryPassword={recoveryPassword}
    serverFeaturedOffers={serverFeaturedOffers}
    serverOffers={serverOffers}
    smallAds={smallAds}
  />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const [
      serverOffers,
      serverFeaturedOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          cardAd: cardsAds = [],
          homeAd: landscapeAds = [],
          smallAd: smallAds = [],
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getTopOffersList({ limit: OFFERS_SERVER_LIMIT, ...query }),
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        cardsAds,
        landscapeAds,
        serverFeaturedOffers,
        serverOffers,
        smallAds,
        [APP.CTX_OPTIONAL_PROPS]: {
          activeOffersListTab: TAB_NAME,
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default MenorPreco;
